module.exports = __webpack_public_path__ + "img/jubao.9b36963f.png";